import apiFetch from '../apiFetch'

export default function (token, manager) {
  return apiFetch({ endPoint: 'ProcessingAgencyManagers/Update', method: 'PUT', body: manager, token: token })
}
